// LogRocket privacy options for the L&D deposit app (LP-2622), as in lending. LogRocketService loads this file together
// with the SDK, when the browser is idle:
//
//   LogRocket.init(environment.logRocket.appId, buildLogRocketPrivacyOptions());
//
// Every option only affects what LogRocket records; none of them change DOM, routing or HTTP behaviour for applicants.

import {logRocketRequestSanitizer, logRocketResponseSanitizer} from './logrocket-network-sanitizer';
import {buildLogRocketRedactSelectors, LOGROCKET_HIDE_SELECTORS} from './logrocket-pii-selectors';
import {LogRocketPrivacyOptions} from './logrocket-privacy.types';
import {sanitizeLogRocketUrl} from './logrocket-url-sanitizer';

export function buildLogRocketPrivacyOptions(): LogRocketPrivacyOptions {
    return {
        // IP address is personal information under CCPA.
        shouldCaptureIP: false,
        // The app logs whole applicant objects (every applicant on the application), search data and auth tokens to the
        // console, and the SDK has no console sanitizer, so console output is not recorded. The browser console is unaffected.
        console: {isEnabled: false},
        dom: {
            // Every input/textarea/select value is masked by redactSelectors (LOGROCKET_FORM_VALUE_ELEMENTS) unless the field
            // is visible (e.g. work phone). inputSanitizer is off because it cannot exempt single fields.
            inputSanitizer: false,
            // Text is masked only for tagged PII elements (redactSelectors) so replays stay usable.
            textSanitizer: false,
            redactSelectors: buildLogRocketRedactSelectors(),
            hideSelectors: [...LOGROCKET_HIDE_SELECTORS],
            // Input masking does not cover the `value` attribute, where mat-radio and hidden inputs keep their value (device
            // session ids, the Socure key, the Authorize.net token). No visible label in the app comes from `value`.
            hiddenAttributes: ['value'],
        },
        browser: {
            urlSanitizer: sanitizeLogRocketUrl,
        },
        network: {
            requestSanitizer: logRocketRequestSanitizer,
            responseSanitizer: logRocketResponseSanitizer,
        },
    };
}
